<span class="input-component">
    <label>{{ label | translate }}</label>
    <div class="input-group content" [ngClass]="{ 'with-icon': this.icon !== undefined, 'currency': this.icon === 'currency', 'percentage': this.icon === 'percentage' }">
        @if (hasCurrencyMask) {
            <input class="form-control" [formControl]="control" [type]="type" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" min="0" [maxLength]="maxLength" [ngClass]="{ 'is-invalid': control.invalid && control.touched }" />
        } @else if (mask) {
            <input class="form-control" [formControl]="control" [type]="type" [placeholder]="placeholder | translate" [min]="minValue" [max]="maxValue" [mask]="mask" [ngClass]="{ 'is-invalid': control.invalid && control.touched }" />
        } @else {
            <input class="form-control" [formControl]="control" [type]="type" [placeholder]="placeholder | translate" [min]="minValue" [max]="maxValue" [ngClass]="{ 'is-invalid': control.invalid && control.touched }" />
        }

        @if (hasButton) {
            <span class="input-group-text" [ngClass]="{ 'has-action': buttonHasFunction }" (click)="buttonFunction()">
                <ng-content></ng-content>
            </span>
        }
    </div>
</span>
